export const NavbarIcon: React.FC<React.SVGAttributes<{}>> = ({
  width,
  height,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="20"
    viewBox="0 0 29 20"
    fill="none"
	{...props}
  >
    <path
      d="M2 18H27"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M2 10H27"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M2 2L27 2"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);
